import { useSelector } from 'react-redux';
import { selectCountries } from '../store/selectors/commonSelectors';

const useCountries = () => {
  const Countries = useSelector(selectCountries);

  if (Countries) {
    return Countries;
  }
};

useCountries.propTypes = {};

export default useCountries;
